export default __webpack_public_path__ + "static/media/WhatsApp Image 2022-05-16 at 20.09.00.7bb297ba.jpeg";